module.exports = __webpack_public_path__ + "img/money.a6d072c.png";